import React from 'react';
import PropTypes from 'prop-types';

/**
 * Drawn icons: Font Awesome cuts the mark out of the glyph, the design has it black (warning)
 * or white (success). The shape takes currentColor from the theme tokens.
 */
const EssayRestoreStatusIcon = ({ type, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        {type === 'warning'
            ? (
                <React.Fragment>
                    {/* The design's 23x20 triangle, 2px radius, 1.5px border. */}
                    <path
                        d="M 10.89 4.10 Q 12 2.20 13.11 4.10 L 22.39 19.90 Q 23.50 21.80 21.30 21.80
                           L 2.70 21.80 Q 0.50 21.80 1.61 19.90 Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                    />
                    <line
                        x1="12"
                        y1="9.6"
                        x2="12"
                        y2="15.1"
                        strokeWidth="1.9"
                        strokeLinecap="round"
                    />
                    <circle cx="12" cy="18.3" r="1.1" />
                </React.Fragment>
            )
            : (
                <React.Fragment>
                    <circle cx="12" cy="12" r="11" fill="currentColor" strokeWidth="1.5" />
                    <path
                        d="M 7 12.5 L 10 15.5 L 17 8.5"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </React.Fragment>
            )}
    </svg>
);

EssayRestoreStatusIcon.propTypes = {
    type: PropTypes.oneOf(['warning', 'success']).isRequired,
    className: PropTypes.string,
};

EssayRestoreStatusIcon.defaultProps = {
    className: '',
};

export default EssayRestoreStatusIcon;
